import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Constraint, Image, Text } from '@gasbuddy/react-components';
import SubmitReview from '../SubmitReview';
import styles from './NoReviews.module.css';

const cx = classnames.bind(styles);

export default function NoReviews({ stationId }) {
  return (
    <React.Fragment>
      <Constraint className={cx('noReviewsContainer')}>
        <Image
          alt="No reviews"
          className={cx('noReviewsImage')}
          src="/assets-v2/svg/icon-add-review.svg"
        />
        <br />
        <Text size="lg">No reviews yet</Text>
      </Constraint>
      <br />
      <SubmitReview
        notLoggedInLinkText="Log in so you can be the first person to Write a Review"
        openModalLinkText="Be the first person to Write a Review"
        stationId={stationId}
      />
    </React.Fragment>
  );
}

NoReviews.propTypes = {
  stationId: PropTypes.string.isRequired,
};
